import { render, staticRenderFns } from "./InformationModal.vue?vue&type=template&id=37fa7180&scoped=true"
import script from "./InformationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./InformationModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InformationModal.vue?vue&type=style&index=0&id=37fa7180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fa7180",
  null
  
)

export default component.exports